import { formatEventTime, getDefaultEndTime } from "@notemeal/utils-date-time";
export const formatActivity = (activity) => {
    return `${activity.name} (${formatEventTime(activity)})`;
};
export const orderedActivityTypeChoices = ["Practice", "Lift", "Conditioning", "Competition"];
export const orderedActivityTypes = ["practice", "lift", "conditioning", "competition"];
export const activityTypeChoiceToInput = ({ activityTypeChoice, start, end, name }) => {
    return {
        start,
        end: end || getDefaultEndTime(start),
        name: name || activityTypeChoice,
        type: activityTypeChoice === "Practice"
            ? "practice"
            : activityTypeChoice === "Lift"
                ? "lift"
                : activityTypeChoice === "Conditioning"
                    ? "conditioning"
                    : "competition",
    };
};
//# sourceMappingURL=utils.js.map